<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-30 16:07:52
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-30 17:17:47
-->
<template>
  <div class="brand">
    <search-header />
    <div style="width: 1280px; margin: 0 auto">
      <div>
        <div class="brand-title">
          <span class="title" @click="$router.push('/')">首页</span> >
          <span class="title">运营服务</span> > <span class="title">项目管理</span>

          <!-- <span class="active">全部</span>
        <span>商标设计</span>
        <span>申请注册</span>
        <span>商标转让</span> -->
        </div>
      </div>

      <div class="toolbox">
        <span>项目名称：</span>
       <label style="width:150px">
          <a-input v-model="searchform.title"  placeholder="请输入项目名称" style="width:250px" ></a-input>
        </label>
    
        <span>发布时间：</span>
        <a-date-picker
          v-model="searchform.startTime"
          valueFormat="YYYY-MM-DD"
          :format="['YYYY-MM-DD']"
          :locale="locale"
        />
        <a-date-picker
          v-model="searchform.endTime"
          valueFormat="YYYY-MM-DD"
          :format="['YYYY-MM-DD']"
          :locale="locale"
        />
        <input type="button" class="login-button" value="搜索" @click="searchList()" />
           <input
          type="button"
          style="margin-left: 10px"
          class="login-button"
          value="重置"
          @click="searchReload()"
        />
      </div>

      <div class="brand-list">
        <div
          class="brand-item"
          v-for="item in brands"
          :key="item.id"
        >
          <img
            v-if="item.videoId != null"
            :src="item.videoId"
          />
          <div class="brand-item-content">
            <span class="price">￥{{ item.money == 0 ? "面议" : item.money + "元" }}</span>
            <h2 :title="item.title">{{ item.title }}</h2>
               <span>发布时间：{{ dateSubString(item.createTime) }}</span>
          </div>
          <div class="company">
            <div>{{ item.enterpriseId?"企业用户":"个人用户" }}: {{ item.enterpriseName }}</div>
            <a class="concat-btn" href="javascript:;" @click="() => $router.push({ path: '/projectDetail', query: { id: item.id } })"
              >查看详情</a
            >
          </div>
        </div>
          <div class="result-item">
            <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
          </div>
      </div>
    </div>
  </div>
</template>
<script>

import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import pagination from "../components/pagination.vue";
export default {
  
  name: "project",
   components: {
    pagination,
  },
  data() {
    return {
        num: 0,
      limit: 8,
      locale,
      brands: [],
      area: [],
      industry: [],
      searchform: {},
    };
  },
  mounted() {
    this.queryList();
    this.queryArea();
    this.queryIndustry();
  },
  methods: {
      getNew(pageOffset) {
      this.pageIndex = pageOffset;
      this.list = this.queryList();
    },
    searchList() {
      this.queryList();
    },
      searchReload() {
         this.searchform.startTime=""; 
      this.searchform.endTime=""; 
       this.searchform.title=""; 
        this.queryList();
      // request({
      //   url: "/api/client/common/supply/list",
      //   method: "get",
      // }).then((res) => {
      //    if (res.code == "200") {
      //      this.brands = res.data.records;
      //     this.pageIndex = parseInt(res.data.current);
      //     this.num = parseInt(res.data.total);
      //     this.limit = parseInt(res.data.size);
      //    }
      // });
    },
    queryIndustry() {
      request({
        url: "/api/client/common/select/industry",
      }).then((res) => {
        console.log(res);
        this.industry = res.data;
      });
    },
    queryList() {
         this.searchform.page = this.pageIndex;
      this.searchform.pageSize = this.limit;
      request({
        url: "/api/client/common/project/list",
        method: "get",
        params: this.searchform,
      }).then((res) => {
            if (res.code == "200") {
              this.brands = res.data.records;
              this.pageIndex = parseInt(res.data.current);
                this.num = parseInt(res.data.total);
                this.limit = parseInt(res.data.size);
          }
      });
    },
      //截取时间
    dateSubString(data) {
      return data.substring(0, 10);
    },
    queryArea() {
      request({
        url: "/api/client/common/select/area",
      }).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="less">
.result-item {
  width:97%;
 background: #fff;
 text-align: center;
 margin-left:8px ;
  li{
    background: darkgrey;
  }
    
}
.brand-title {
  height: 44px;
  display: flex;
  background: #fff;
  align-items: center;
  border: 1px solid #ccc;
  .title {
    font-size: 14px;
    font-weight: bold;
  }
  span {
    padding: 10px;
  }
  .active {
    color: #1890ff;
  }
}
.toolbox {
  margin: 10px 0;
  background: #fff;
  border: 1px solid #ccc;
  span {
    padding: 10px;
  }
}

.brand-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  margin: 20px 0;
  .brand-item {
    width: 310px;
    height: 500px;
    background: #fff;
    border: 1px solid #ccc;
    padding: 20px;
    margin-bottom: 15px;
    margin-left:13px;
    img {
      width: 270px;
      height: 200px;
      object-fit: contain;
    }
    .brand-item-content {
      margin-top: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      .price {
        color: #ce1b14;
      }
    }
    .company {
      padding-top: 20px;
      color: #333;
      .concat-btn {
        margin: 20px auto;
        border-radius: 8%;
        color: #fff;
        width: 160px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
           background: #0599fb;
      }
    }
  }
}
.selectbox select {
  padding: 6px 30px 6px 15px;
  background: #fff;
  width: 140px;
  height: 30px;
  text-align: left;
  vertical-align: middle;
  border: 1px solid #94c1e7;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  border-radius: 3px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
}

/*LABEL FOR SELECT*/
label.selectbox {
  position: relative;
  display: inline-block;
}

/*DOWNWARD ARROW (25bc)*/
label.selectbox::after {
  content: "\25bc";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  background: #94c1e7;
  color: #2984ce;
  -moz-border-radius: 0 6px 6px 0;
  -webkit-border-radius: 0 6px 6px 0;
  border-radius: 0 6px 6px 0;
  pointer-events: none;
}
.login-button {
  /* 按钮美化 */
  width: 70px; /* 宽度 */
  height: 35px; /* 高度 */
  border-width: 0px; /* 边框宽度 */
  border-radius: 3px; /* 边框半径 */
  background: #1e90ff; /* 背景颜色 */
  cursor: pointer; /* 鼠标移入按钮范围时出现手势 */
  outline: none; /* 不显示轮廓线 */
  font-family: Microsoft YaHei; /* 设置字体 */
  color: white; /* 字体颜色 */
  font-size: 17px; /* 字体大小 */
}
.login-button:hover {
  /* 鼠标移入按钮范围时改变颜色 */
  background: #5599ff;
}
.brand-list .brand-item:nth-child(1){
    margin-left:0px !important;
  } 
  
.brand-list .brand-item:nth-child(5){
    margin-left:0px !important;
  } 
</style>
